export type ContactStatus = 'new' | 'read' | 'replied' | 'closed';

export interface ContactMessage {
  id: string;
  fullName: string;
  email: string;
  phone?: string;
  desk: string;
  subject: string;
  message: string;
  country?: string;
  state?: string;
  city?: string;
  status: ContactStatus;
  submittedAt?: string;
  createdAt?: string;
  updatedAt?: string;
}

export type ContactStatusFilter = ContactStatus | 'all';

export interface ContactListParams {
  page?: number;
  limit?: number;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
  search?: string;
  status?: ContactStatusFilter;
  desk?: string;
}

export interface PaginatedContacts {
  results: ContactMessage[];
  total: number;
  page: string;
  limit: string;
  sortBy: string;
  sortOrder: 'asc' | 'desc';
}

export interface UpdateContactStatusPayload {
  status: ContactStatus;
}

export interface BulkContactIdsPayload {
  ids: string[];
}

export interface BulkContactStatusPayload extends BulkContactIdsPayload {
  status: ContactStatus;
}

export const CONTACT_STATUS_OPTIONS: { value: ContactStatus | 'all'; label: string }[] = [
  { value: 'all', label: 'All statuses' },
  { value: 'new', label: 'New' },
  { value: 'read', label: 'Read' },
  { value: 'replied', label: 'Replied' },
  { value: 'closed', label: 'Closed' },
];

export const CONTACT_DESK_OPTIONS = [
  'Library & Institutional Sales',
  'Subscriptions & Digital',
  'Press & Newsroom',
  'General enquiry',
  'Quotation',
] as const;
